<db-booster-page-score class="db-booster__disconnected-layout"
                       [companyName]="companyName"
                       [websiteId]="website?.id" [websiteUrl]="website?.site_url" [websiteHosted]="!!website?.domain_hash"
                       [trialBoosterWithHosted]="userSubscription?.trialBoosterClient && !!website?.domain_hash"
                       [userSubscription]="userSubscription"
                       [websiteScore]="website?.score"></db-booster-page-score>
